import * as actions_assets from 'actions/assets-actions';
import * as toolbox from 'components/common/toolbox';
import * as types from './action-types';
import _ from 'lodash';
import firebase from 'firebase/compat/app';
import { ROLES, WORKORDERS_CHECKEDIN_STATUSES } from 'components/constants';
import { deleteField } from 'firebase/firestore';

const firestore = firebase.firestore();

/*-----------------------------------------------*/
/*  USERS
/*-----------------------------------------------*/

export function subUser(handle, email, callback) {

	return dispatch => {

		dispatch({ type: types.USER + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/users/users').doc(email).onSnapshot(async(doc) => {
			var user = { ...doc.data(), id: doc.id };

			if (user.deleted) {
				window.toastr.error(`The user ${email} is no longer active.  Please check with an Administrator`, 'User Deleted');
				setTimeout(() => {
					firebase.auth().signOut().then(() => {
						setTimeout(() => {
							dispatch({ type: types.LOGOUT });
						}, 500);
					}).catch((error) => {
						toolbox.process_error(error, 'Logout: ' + error.message);
					});
				}, 500);
			}

			const snapshot = await firestore.collection(handle + '/contacts/contacts').where('email', '==', email).get();
			var contact = (!snapshot.empty) ? { ...snapshot.docs[0].data(), id: snapshot.docs[0].id } : null;

			var companies = [];
			const snapshot2 = await firestore.collection('_companies').get();
			snapshot2.forEach((doc) => { 
				companies.push({ ...doc.data(), id: doc.id }); 
			});	

			// If UserRole is Customer, set selectedCustomerId
			if (user.roles?.includes(ROLES.ASSET_CUSTOMER.id)) {
				dispatch(actions_assets.selectCustomer(handle, user.profileId));
			}

			// Find all accounts for which this user is Authorized
			var locations = [];
			const snapshot3 = await firestore.collectionGroup('users').where('email', '==', email).get();
			snapshot3.forEach((doc) => {
				let handle = doc.ref.parent.parent.parent.id;
				let company = _.find(companies, { id: handle });
				locations.push({ name: company?.companyName ?? handle, handle: handle }); 
			});	

			dispatch({ type: types.USER + '_FULFILLED', data: { ...user, email, contact, locations }, unsubscribe });
			if (typeof callback === 'function') callback(user);

			// -------------------------------------------------------------------------
			// Check if previously checked in to Work Order or Task
			// -------------------------------------------------------------------------

			if (user.lastCheckInWorkOrderId) {
				firestore.collection(handle + '/work-orders/work-orders').doc(user.lastCheckInWorkOrderId).get().then((doc) => {
					var workOrder = { ...doc.data(), id: doc.id };
					if (WORKORDERS_CHECKEDIN_STATUSES.includes(workOrder?.statusId)) {
						dispatch({ type: types.WORK_ORDER_CHECKED_IN, data: workOrder });
					} else {
						dispatch({ type: types.WORK_ORDER_CHECKED_IN, data: null });
					}
				});
			} else {
				dispatch({ type: types.WORK_ORDER_CHECKED_IN, data: null });
			}
			
			if (user.lastCheckInTaskId) {
				firestore.collection(handle + '/settings/tasks').doc(user.lastCheckInTaskId).get().then((doc) => {
					var task = { ...doc.data(), id: doc.id };
					if (task.checkedIn?.includes(user.email)) {
						dispatch({ type: types.TASK_CHECKED_IN, data: task });
					} else {
						dispatch({ type: types.TASK_CHECKED_IN, data: null });
					}
				});
			} else {
				dispatch({ type: types.TASK_CHECKED_IN, data: null });
			}
		});
	};
}
export function subUserPermissions(handle, email, roleId) {

	return async dispatch => {

		dispatch({ type: types.USER_PERMISSIONS + '_PENDING' });

		if (email) {
			var unsubscribe = firestore.collection(handle).doc('settings').onSnapshot(async (doc) => {
				const permissionsData = doc.data()?.permissions ?? {};
				const assetsData = doc.data()?.assets ?? {};

				var userDoc = await firestore.collection(handle + '/users/users').doc(email).get();
				const userPermissions = userDoc.data()?.user_permissions ?? {};
				const userRoles = userDoc.data().roles;
				const profileId = userDoc.data().profileId;

				var permissions = { 
					SUPERADMIN: userRoles.includes('9999'),
					OWNER: userRoles.includes(ROLES.OWNER.id), 
					ADMINISTRATOR: userRoles.includes(ROLES.ADMINISTRATOR.id),
					ASSET_CUSTOMER: userRoles.includes(ROLES.ASSET_CUSTOMER.id),
					SERVICE_CUSTOMER: userRoles.includes(ROLES.SERVICE_CUSTOMER.id),
					EXTERNAL_USER: userRoles.includes(ROLES.EXTERNAL_USER.id),
				};

				if (userRoles.includes(ROLES.EXTERNAL_USER.id)) {
					permissions.ANALYTICS_ASSETS = userPermissions.permAnalytics;
					permissions.ASSETS_VIEW = userPermissions.permAssets;
					permissions.SERVICE_REQUESTS_CREATE = userPermissions.permCreateRequests;
					permissions.ASSETS_EDIT = userPermissions.permEditAssets;
					permissions.INVOICES_VIEW = userPermissions.permInvoices;
					permissions.ASSETS_LIC_DOCS = userPermissions.permLicensesDocs;
					permissions.SERVICE_REQUESTS_VIEW = userPermissions.permServiceHistory;
					permissions.WORK_ORDERS_VIEW = userPermissions.permWorkOrdersQuotes;
					permissions.QUOTES_VIEW = userPermissions.permWorkOrdersQuotes;
					permissions.INVENTORY_VIEW = false;
					permissions.USERS_VIEW = false;

				} else if (userRoles.includes(ROLES.ASSET_CUSTOMER.id)) {
					permissions.ANALYTICS_ASSETS = assetsData.permAnalytics;
					permissions.ASSETS_VIEW = assetsData.permAssets;
					permissions.SERVICE_REQUESTS_CREATE = assetsData.permCreateRequests;
					permissions.ASSETS_CREATE = assetsData.permAddAssets;
					permissions.ASSETS_EDIT = assetsData.permEditAssets;
					permissions.INVOICES_VIEW = assetsData.permInvoices;
					permissions.ASSETS_LIC_DOCS = assetsData.permLicensesDocs;
					permissions.SERVICE_REQUESTS_VIEW = assetsData.permServiceHistory;
					permissions.WORK_ORDERS_VIEW = assetsData.permWorkOrdersQuotes;
					permissions.QUOTES_VIEW = assetsData.permWorkOrdersQuotes;
					permissions.INVENTORY_VIEW = false;

				} else {
					Object.keys(permissionsData).forEach((key) => {
						permissions[key] = (permissionsData[key].excluded?.find((exc) => exc.value == profileId)) 
							? false
							: (permissionsData[key].included?.find((inc) => inc.value == profileId)) 
								? true
								: permissionsData[key].roles?.find((role) => userRoles.includes(role.toString())) != undefined;
					});
				}

				
				dispatch({ type: types.USER_PERMISSIONS + '_FULFILLED', data: permissions, unsubscribe });
			});

		} else if (roleId) {
			
			var settingsDoc = await firestore.collection(handle).doc('settings').get();
			const permissionsData = settingsDoc.data().permissions ?? {};

			var permissions = { OWNER: roleId == ROLES.OWNER.id, ADMINISTRATOR: roleId == ROLES.ADMINISTRATOR.id };

			Object.keys(permissionsData).forEach((key) => {
				console.log(permissionsData[key].roles?.find((role) => role == roleId));
				permissions[key] = permissionsData[key].roles?.find((role) => role == roleId) != undefined;
			});

			dispatch({ type: types.USER_PERMISSIONS + '_FULFILLED', data: permissions, unsubscribe });
		}
	};
}
export function subUsers(handle) {

	return async dispatch => {

		dispatch({ type: types.USERS + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/users/users').where('roles', 'array-contains-any', [ROLES.EXTERNAL_USER.id]).onSnapshot((snapshot) => {
			var users = [];
			snapshot.docs.forEach((doc) => {
				users.push({ ...doc.data(), id: doc.id });
			});
			dispatch({ type: types.USERS + '_FULFILLED', data: users, unsubscribe });
		});
	};
}

export function updateUser(handle, email, userUpdate, callback) {

	return async dispatch => {

		const snapshot = await firestore.collection(handle + '/users/users').where('email', '==', email).get();
		if (snapshot.empty) return;

		const userDoc = snapshot.docs[0];
		const user = { ...userDoc.data(), id: userDoc.id };
		
		if (user) {
			
			dispatch({ type: types.USER + '_SAVE_PENDING' });
	
			const batch = firestore.batch();
			const userRef = firestore.collection(handle + '/users/users');
			const profileRef = firestore.collection(handle + '/profiles/profiles');
	
			batch.set(userRef.doc(email), { ...userUpdate }, { merge: true });
	
			if (user.profileId) batch.set(profileRef.doc(user.profileId), { 
				modified: new Date(),
				...(userUpdate.roles) ? [{ roles: userUpdate.roles }] : [{}], // update only if userUpdate includes roles
			}, { merge: true });
	
			batch.commit().then(() => {
				window.toastr.success('The User record has been successfully saved/updated', 'User Saved!');
				dispatch({ type: types.USER + '_SAVE_FULFILLED' });
				if (typeof callback === 'function') callback(email);
			}).catch((error) => {
				toolbox.process_error(error, 'User NOT Saved!');
			});
		}
	};
}
export function createUser(handle, email, firstName, lastName, profileId, roleId, callback) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		const batch = firestore.batch();
		const userRef = firestore.collection(handle + '/users/users').doc(email);
		const userDoc = await userRef.get();
		const user = userDoc.data();
		const defaultUserPermissions = {
			permAssets: true,
			permCreateRequests: true,
			permLicensesDocs: true,
			permServiceHistory: true,
			permWorkOrdersQuotes: true,
		}

		if (userDoc.exists && user.roles?.length) {
			window.toastr.error('A User record with this email has already been created', 'User NOT Saved!');
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
			return;
		} else if (userDoc.exists && !user.roles?.length) {
			batch.set(userRef, { 
				firstName,
				lastName,
				roles: firebase.firestore.FieldValue.arrayUnion(roleId), 
				user_permissions: defaultUserPermissions,
				modified: new Date() 
			}, { merge: true });
		} else {
			batch.set(userRef, {
				deleted: false,
				email,
				firstName,
				lastName,
				roles: [roleId],
				profileId,
				user_permissions: defaultUserPermissions,
				created: new Date(),
				modified: new Date(),
			}, { merge: true });
		}

		if (profileId) batch.set(firestore.collection(handle + '/profiles/profiles').doc(profileId), { modified: new Date() }, { merge: true });

		batch.commit().then(() => {
			window.toastr.success('The User record has been successfully saved/updated', 'User Saved!');
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
			if (typeof callback === 'function') callback(email);
		}).catch((error) => {
			toolbox.process_error(error, 'User NOT Saved!');
		});
	};
}
export function addRemoveUserRole(handle, email, roleId, add, callback) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		const batch = firestore.batch();
		const userRef = firestore.collection(handle + '/users/users').doc(email);
		const userDoc = await userRef.get();
		const user = userDoc.data();

		if (userDoc.exists) {
			batch.set(userRef, { 
				roles: (add) 
				? firebase.firestore.FieldValue.arrayUnion(roleId) 
				: firebase.firestore.FieldValue.arrayRemove(roleId), 
				modified: new Date() 
			}, { merge: true });
			if (user.profileId) batch.set(firestore.collection(handle + '/profiles/profiles').doc(user.profileId), { modified: new Date() }, { merge: true });
		}

		batch.commit().then(() => {
			window.toastr.success('The User record has been successfully saved/updated', 'User Saved!');
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
			if (typeof callback === 'function') callback(email);
		}).catch((error) => {
			toolbox.process_error(error, 'User NOT Saved!');
		});
	};
}
export function saveToken(platform, token, user) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		const userSnapshot = await firestore.collectionGroup('users').where('email', '==', user.email).get();
		var users = [];
		userSnapshot.forEach((doc) => {
			users.push({ ...doc.data(), id: doc.id, handle: doc.ref.parent.parent.parent.id });
		});

		for (let user of users) {
			let platformToken = platform + ':' + token;
			await firestore.collection(user.handle + '/users/users').doc(user.email).update({ tokens: firebase.firestore.FieldValue.arrayUnion(platformToken) });
		}
	
		dispatch({ type: types.USER + '_SAVE_FULFILLED' });
	};
}
export function viewAs(email) {
	return async dispatch => {
		dispatch({ type: types.VIEW_AS, data: email });
	};
}
export function dismissNotice(handle, email, noticeId) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });
		await firestore.collection(handle + '/users/users').doc(email).update({ [`dismissed.${noticeId}`]: true });
		dispatch({ type: types.USER + '_SAVE_FULFILLED' });
	};
}
export function deleteUser(handle, email, callback) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		firestore.collection(handle + '/users/users').doc(email).delete().then(() => {
			window.toastr.success('The User record has been permanently deleted', 'User Saved!');
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
			if (typeof callback === 'function') callback(email);
		}).catch((error) => {
			toolbox.process_error(error, 'User NOT Saved!');
		});
	};
}
export function subUserLocationsByDate(handle, email, date, callback) {

	return dispatch => {

		if (email) {

			dispatch({ type: types.USER_LOCATIONS + '_PENDING' });

			var beginningOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
			var endOfDay = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);

			var unsubscribe = firestore.collection(handle + '/users/users/' + email + '/locations').where('timestamp', '>=', beginningOfDay).where('timestamp', '<', endOfDay).onSnapshot((querySnapshot) => {

				var locations = [];
				querySnapshot.forEach((doc) => {
					locations.push({ ...doc.data(), id: doc.id });
				});

				dispatch({ type: types['USER_LOCATIONS'] + '_FULFILLED', data: locations, unsubscribe });
				if (typeof callback === 'function') callback();
			});
		} else {
			console.error('Missing Email on Location search');
		}
	};
}

// export function subUserLocations(handle, email, callback) {

// 	return dispatch => {

// 		dispatch({ type: types.USER_LOCATIONS + '_PENDING' });

// 		var unsubscribe = firestore.collection(handle + '/users/users/' + email + '/locations').get().then((querySnapshot) => {

// 			var locations = [];
// 			querySnapshot.forEach((doc) => {
// 				locations.push({ ...doc.data(), id: doc.id });
// 			});

// 			dispatch({ type: types.USER_LOCATIONS + '_FULFILLED', data: locations, unsubscribe });
// 			if (typeof callback === 'function') callback();
// 		});
// 	};
// }

/*-----------------------------------------------*/
/*  SERVICE ITEMS
/*-----------------------------------------------*/

export function addItemToRecent(handle, item, userId) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		firestore.collection(handle + '/users/users/' + userId + '/items').doc('items').set({ recent: { [item.id]: new Date() } }, { merge: true }).then(() => {
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
		}).catch((error) => {
			toolbox.process_error(error, 'Unable to add item to recents!');
		});
	};
}
export function trimRecent(handle, recentArray, typeId, userId) {

	return async dispatch => {

		dispatch({ type: types.USER + '_SAVE_PENDING' });

		var batch = firestore.batch();
		var deleteValues = recentArray.slice(50);
		deleteValues.forEach((value) => {
			batch.set(firestore.collection(handle + '/users/users/' + userId + '/service-items').doc(typeId.toString()), { recent: { [value.id]: deleteField() } }, { merge: true });
		});

		batch.commit().then(() => {
			dispatch({ type: types.USER + '_SAVE_FULFILLED' });
		}).catch((error) => {
			toolbox.process_error(error, 'Unable to add item to recents!');
		});
	};
}
export function subUserRecentItems(handle, email) {

	return dispatch => {

		dispatch({ type: types.USER_RECENT_ITEMS + '_PENDING' });

		var unsubscribe = firestore.collection(handle + '/users/users/' + email + '/items').onSnapshot((querySnapshot) => {

			var recentItems = {};
			querySnapshot.forEach((doc) => {
				recentItems[doc.id] = doc.data();
			});

			dispatch({ type: types.USER_RECENT_ITEMS + '_FULFILLED', data: recentItems, unsubscribe });
		});
	};
}